export const brandBgEntityId = {
  type: "number",
  minimum: 0,
  maximum: Number.MAX_SAFE_INTEGER
};
